/**
 * O traço dos ícones — só o `d` de um `<path>`, nada mais.
 *
 * ARQUIVO GERADO. Não edite à mão: `node scripts/generate-icons.mjs` reescreve
 * este arquivo a partir do Lucide 0.545.0 (devDependency `lucide-static`), e é
 * lá que se acrescenta um ícone ou se troca o traço de um.
 *
 * ── POR QUE UM CONJUNTO DE FORA ───────────────────────────────────────────
 *
 * Os traços eram desenhados à mão aqui, e o preço apareceu junto: cada um tinha a
 * sua espessura ótica, o seu raio de canto e a sua margem dentro do quadrado, de
 * modo que quinze ícones lado a lado na lateral não pareciam quinze irmãos.
 * Desenhar melhor não conserta isso — só um conjunto que já foi desenhado inteiro
 * pela mesma mão conserta. O Lucide é ISC, tem a mesma grade de 24 e o mesmo
 * contorno de 2, então ele entra sem que uma linha de quem desenha mude.
 *
 * ── POR QUE DADO E NÃO COMPONENTE ─────────────────────────────────────────
 *
 * Porque `design/` não pode saber de rota nem de feature (`.dependency-cruiser`,
 * `design-is-independent`), e um componente que recebesse "o ícone de Conversas"
 * já saberia. Aqui não há tela nenhuma: há um traço chamado `envelope`, e quem
 * decide que Conversas se desenha com um envelope é a navegação.
 *
 * Todos no mesmo `viewBox="0 0 24 24"`, pensados para `stroke="currentColor"`,
 * `fill="none"`, `stroke-width="2"` e pontas redondas — que é o que `Icon.vue`
 * já aplica. Um ícone tem vários `M` no mesmo `d` porque o Lucide o descreve com
 * vários elementos; o traço desenhado é o mesmo.
 *
 * A exceção são as MARCAS no fim do mapa (`FILLED_ICONS`): elas não vêm do Lucide,
 * são desenhadas no próprio script e saem CHEIAS, com o vazado por `evenodd`.
 *
 * ── LICENÇA ───────────────────────────────────────────────────────────────
 *
 * Lucide (ISC). Copiado do LICENSE do pacote, como a licença exige:
 *
 * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
 * Copyright (c) 2013-2023 Cole Bemis
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
export const ICONS = {
	/** Instagram: a rede de fotos. */
	instagram:
		"M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1 -5 5h-10a5 5 0 0 1 -5 -5v-10a5 5 0 0 1 5 -5ZM16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37zM17.5 6.5L17.51 6.5",
	/** Webchat: a janela do próprio site. */
	webchat:
		"M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2ZM10 4v4M2 8h20M6 4v4",
	/** Globo. O site do negócio na internet. */
	globe:
		"M2 12a10 10 0 1 0 20 0a10 10 0 1 0 -20 0M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20M2 12h20",
	/** Casa. Onde se começa. */
	home: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
	/** Brilho. O que a máquina faz sozinha. */
	sparkle:
		"M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594zM20 2v4M22 4h-4M2 20a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
	/** Envelope. O que alguém escreveu. */
	envelope:
		"M22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2Z",
	/** Bandeja com seta. A fila de tudo que chegou. */
	inbox:
		"M22 12L16 12L14 15L10 15L8 12L2 12M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
	/** Alvo. O que está em curso e tem um fim. */
	target:
		"M2 12a10 10 0 1 0 20 0a10 10 0 1 0 -20 0M6 12a6 6 0 1 0 12 0a6 6 0 1 0 -12 0M10 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
	/** Pergunta. Alguém esperando resposta. */
	question:
		"M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01",
	/** Pulso. Se está de pé. */
	pulse:
		"M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
	/** Ficha com um rosto. Pessoas. */
	addressBook:
		"M16 2v2M17.915 22a6 6 0 0 0-12 0M8 2v2M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2Z",
	/** Colunas de alturas diferentes. Um quadro. */
	columns:
		"M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2ZM8 7v7M12 7v4M16 7v9",
	/** Ondas saindo de um ponto. Por onde a mensagem chega. */
	broadcast:
		"M16.247 7.761a6 6 0 0 1 0 8.478M19.075 4.933a10 10 0 0 1 0 14.134M4.925 19.067a10 10 0 0 1 0-14.134M7.753 16.239a6 6 0 0 1 0-8.478M10 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
	/** Raio. Algo que dispara sem ninguém. */
	bolt: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
	/** Caixas ligadas. Uma regra que corre sozinha. */
	workflow:
		"M5 3h4a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2ZM7 11v4a2 2 0 0 0 2 2h4M15 13h4a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2Z",
	/** Chave inglesa. Uma ferramenta que se acopla. */
	wrench:
		"M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
	/** Lápis. Renomear aqui mesmo, sem abrir formulário. */
	pencil:
		"M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497zM15 5l4 4",
	/** Pega de arrasto. Segure e mude a ordem. */
	grip: "M8 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0M8 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0M8 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0M14 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0M14 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0M14 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
	/** Mais. Criar a partir daqui. */
	plus: "M5 12h14M12 5v14",
	/** Sino cortado. Aviso sonoro desligado. */
	bellOff:
		"M10.268 21a2 2 0 0 0 3.464 0M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742M2 2l20 20M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05",
	/** Uma pessoa. O responsável humano. */
	user: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2M8 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
	/** Nós ligados. O que ficou sabido. */
	nodes:
		"M9.5 4.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0M10.2 6.3l-3.9 3.9M2 12a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0M7 12h10M17 12a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0M13.8 17.7l3.9-3.9M9.5 19.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0",
	/** Cérebro. O que os agentes sabem. */
	brain:
		"M12 18V5M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5M17.997 5.125a4 4 0 0 1 2.526 5.77M18 18a4 4 0 0 0 2-7.464M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517M6 18a4 4 0 0 1-2-7.464M6.003 5.125a4 4 0 0 0-2.526 5.77",
	/** Quadrícula. As telas e os campos. */
	grid: "M4 3h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1ZM15 3h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1ZM15 14h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1ZM4 14h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1Z",
	/** Camadas. Um pacote pronto para aplicar. */
	layers:
		"M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83zM2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
	/** Folha escrita. Um arquivo. */
	document:
		"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7ZM14 2v4a2 2 0 0 0 2 2h4M10 9H8M16 13H8M16 17H8",
	/** Duas pessoas. Quem trabalha aqui. */
	users:
		"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3.128a4 4 0 0 1 0 7.744M22 21v-2a4 4 0 0 0-3-3.87M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
	/** Controles. O que se ajusta uma vez e vale para tudo. */
	sliders: "M10 5H3M12 19H3M14 3v4M16 17v4M21 12h-9M21 19h-5M21 5h-7M8 10v4M8 12H3",
	/** Microfone. A voz com que o atendente fala. */
	mic: "M12 19v3M19 10v2a7 7 0 0 1-14 0v-2M12 2h0a3 3 0 0 1 3 3v7a3 3 0 0 1 -3 3h0a3 3 0 0 1 -3 -3v-7a3 3 0 0 1 3 -3Z",
	/** Engrenagem. Onde tudo se configura. */
	settings:
		"M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915M9 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0",
	/** Ponteiro de medidor. Quanto já se gastou. */
	gauge: "M12 14l4-4M3.34 19a10 10 0 1 1 17.32 0",
	/** Barras. Os números lidos. */
	chart: "M3 3v16a2 2 0 0 0 2 2h16M18 17V9M13 17V5M8 17v-3",
	/** Livro aberto. Como isto funciona. */
	book: "M12 7v14M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
	/** Racks. A instalação inteira, não este workspace. */
	server:
		"M4 2h16a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2ZM4 14h16a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2ZM6 6L6.01 6M6 18L6.01 18",
	/** Linhas de texto. O que se diz a cada função. */
	lines: "M21 5H3M15 12H3M17 19H3",
	/** Sino. */
	bell: "M10.268 21a2 2 0 0 0 3.464 0M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
	/** Três barras. Abrir o menu. */
	menu: "M4 5h16M4 12h16M4 19h16",
	/** Lupa. */
	search: "M21 21l-4.34-4.34M3 11a8 8 0 1 0 16 0a8 8 0 1 0 -16 0",
	/** Círculo meio a meio. O tema, seja ele qual for. */
	contrast: "M2 12a10 10 0 1 0 20 0a10 10 0 1 0 -20 0M12 18a6 6 0 0 0 0-12v12z",
	/** Sol. O tema claro. */
	sun: "M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41",
	/** Lua. O tema escuro. */
	moon: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
	/** Tela. O que o sistema disser. */
	monitor:
		"M4 3h16a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2ZM8 21L16 21M12 17L12 21",
	/** Alfinete. Deixar o painel aberto. */
	pin: "M12 17v5M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
	/** Alfinete riscado. Soltar o painel. */
	pinOff:
		"M12 17v5M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89M2 2l20 20M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
	/** Porta com seta. Sair. */
	logOut: "M16 17l5-5-5-5M21 12H9M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
	/** Seta para baixo. Um grupo aberto. */
	chevronDown: "M6 9l6 6 6-6",
	/** Seta para a direita. Um grupo fechado. */
	chevronRight: "M9 18l6-6-6-6",
	/** Seta para a esquerda. O rail devolvendo espaço. */
	chevronLeft: "M15 18l-6-6 6-6",
	/** Funil. */
	funnel:
		"M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
	/** Cartão. O que se paga por este workspace. */
	creditCard:
		"M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2ZM2 10L22 10",
	/** Recibo. O que a instalação cobrou. */
	receipt:
		"M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1ZM16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8M12 17.5v-11",
	/** Etiqueta de preço. O que se vende. */
	tag: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42zM7 7.5a0.5 0.5 0 1 0 1 0a0.5 0.5 0 1 0 -1 0",
	/** Aperto de mãos. Quem indicou. */
	handshake:
		"M11 17l2 2a1 1 0 1 0 3-3M14 14l2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4M21 3l1 11h-2M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3M3 4h8",
	/** Mão levantada. Assumir a conversa. */
	hand: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
	/** Robô. O assistente que responde sozinho. */
	bot: "M12 8V4H8M6 8h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2ZM2 14h2M20 14h2M15 13v2M9 13v2",
	/** Setas trocando de lado. Mudar de mão. */
	transfer: "M8 3 4 7l4 4M4 7h16M16 21l4-4-4-4M20 17H4",
	/** Certo. Dar por resolvido. */
	check: "M20 6 9 17l-5-5",
	/** Seta que volta. Reabrir o que se fechou. */
	reopen: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8M3 3v5h5",
	/** Nota adesiva. O que a equipe anota e o cliente não vê. */
	note: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8ZM15 3v4a2 2 0 0 0 2 2h4",
	/** Bandeira. A urgência. */
	flag: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
	/** Três pontos. O resto das ações. */
	more: "M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0M11 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0M11 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
	/** Xis. Fechar. */
	close: "M18 6 6 18M6 6l12 12",
	/** Câmera. Trocar a foto desta conta. */
	camera:
		"M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4zM9 13a3 3 0 1 0 6 0a3 3 0 1 0 -6 0",
	/** Um QR: quatro cantos e o miolo. Conectar lendo com o celular. */
	qrCode:
		"M4 3h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1ZM17 3h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1ZM4 16h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1ZM21 16h-3a2 2 0 0 0-2 2v3M21 21v.01M12 7v3a2 2 0 0 1-2 2H7M3 12h.01M12 3h.01M12 16v.01M16 12h1M21 12v.01M12 21v-1",
	/** Relógio. Quanto tempo passou. */
	clock: "M12 6v6l4 2M2 12a10 10 0 1 0 20 0a10 10 0 1 0 -20 0",
	/** Triângulo de aviso. Passou da hora. */
	alert:
		"M21.73 18l-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3M12 9v4M12 17h.01",
	/** Cadeado. Guardado, mas fechado até o plano ter folga. */
	lock: "M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-7a2 2 0 0 1 2 -2ZM7 11V7a5 5 0 0 1 10 0v4",
	/** Ampulheta. Alguém aguarda resposta. */
	hourglass:
		"M5 22h14M5 2h14M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2",
	/** Floco de neve. O que esfriou sem ninguém tocar. */
	snowflake:
		"M10 20l-1.25-2.5L6 18M10 4 8.75 6.5 6 6M14 20l1.25-2.5L18 18M14 4l1.25 2.5L18 6M17 21l-3-6h-4M17 3l-3 6 1.5 3M2 12h6.5L10 9M20 10l-1.5 2 1.5 2M22 12h-6.5L14 15M4 10l1.5 2L4 14M7 21l3-6-1.5-3M7 3l3 6h4",
	/** Chama. O que está quente agora. */
	flame:
		"M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4",
	/** Balão de fala. Abrir a conversa. */
	chat: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
	/** Pessoa com mais. Assumir para si. */
	userPlus:
		"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0M19 8L19 14M22 11L16 11",
	/** Seta para a direita. Abrir o detalhe. */
	arrowRight: "M5 12h14M12 5l7 7-7 7",
	/** Seta para cima. Subir um item na ordem. */
	arrowUp: "M5 12l7-7 7 7M12 19V5",
	/** Seta para baixo. Descer um item na ordem. */
	arrowDown: "M12 5v14M19 12l-7 7-7-7",
	/** Seta adiante. Mensagem encaminhada. */
	forward: "M15 17l5-5-5-5M4 18v-2a4 4 0 0 1 4-4h12",
	/** Círculo cortado. Proibido, recusado, sem acesso. */
	ban: "M4.929 4.929 19.07 19.071M2 12a10 10 0 1 0 20 0a10 10 0 1 0 -20 0",
	/** Traço. Diminuir (o zoom de um desenho). */
	minus: "M5 12h14",
	/** Seta na diagonal. Abrir noutro lugar. */
	arrowUpRight: "M7 7h10v10M7 17 17 7",
	/** Lista. As mesmas linhas, uma embaixo da outra. */
	list: "M3 5h.01M3 12h.01M3 19h.01M8 5h13M8 12h13M8 19h13",
	/** Moldura com um sol. Uma imagem. */
	image:
		"M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2ZM7 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0M21 15l-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
	/** Rolo de filme. Um vídeo. */
	film: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2ZM7 3v18M3 7.5h4M3 12h18M3 16.5h4M17 3v18M17 7.5h4M17 16.5h4",
	/** Nota musical. Um áudio. */
	music: "M9 18V5l12-2v13M3 18a3 3 0 1 0 6 0a3 3 0 1 0 -6 0M15 16a3 3 0 1 0 6 0a3 3 0 1 0 -6 0",
	/** Caixa de arquivo. Um pacote comprimido. */
	archive:
		"M3 3h18a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1ZM4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8M10 12h4",
	/** Folha em branco. Um arquivo de tipo que não se reconhece. */
	file: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7ZM14 2v4a2 2 0 0 0 2 2h4",
	/** Seta para uma bandeja. Trazer para o computador. */
	download: "M12 15V3M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5",
	/** Dois elos. O endereço de uma coisa. */
	link: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71",
	/** Seta saindo de uma bandeja. Enviar para cá. */
	upload: "M12 3v12M17 8l-5-5-5 5M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
	/** Lixeira. Apagar. */
	trash:
		"M10 11v6M14 11v6M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
	/** Olho. Ver de perto, sem sair da tela. */
	eye: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0M9 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0",
	/** O olho riscado: a senha visível volta a ser segredo. Par do `eye`. */
	eyeOff:
		"M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49M14.084 14.158a3 3 0 0 1-4.242-4.242M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143M2 2l20 20",
	/** Duas folhas. Copiar o texto. */
	copy: "M10 8h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2ZM4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
	/** Setas em círculo. Pedir de novo. */
	refresh:
		"M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8M21 3v5h-5M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16M8 16H3v5",
	/** Seta voltando. Usar como resposta. */
	reply: "M20 20v-7a4 4 0 0 0-4-4H4M9 14 4 9l5-5",
	/** Polegar para cima. Foi útil. */
	thumbsUp:
		"M7 10v12M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
	/** Polegar para baixo. Não foi útil. */
	thumbsDown:
		"M17 14V2M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
	/** Clipe. Anexar um arquivo à mensagem. */
	paperclip:
		"M16 6l-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
	/** Avião de papel. Enviar a mensagem. */
	send: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11zM21.854 2.147l-10.94 10.939",
	/** Triângulo. Ouvir o áudio. */
	play: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
	/** Duas barras. Parar de ouvir. */
	pause:
		"M15 3h3a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1ZM6 3h3a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1Z",
	/** Rosto. Escolher um emoji. */
	smile: "M2 12a10 10 0 1 0 20 0a10 10 0 1 0 -20 0M8 14s1.5 2 4 2 4-2 4-2M9 9L9.01 9M15 9L15.01 9",
	/** Relógio com seta de volta. As conversas anteriores. */
	history: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8M3 3v5h5M12 7v5l4 2",
	/** Folha com lápis. Começar uma conversa nova. */
	compose:
		"M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
	/** Setas para os cantos. Ocupar a tela. */
	maximize: "M15 3h6v6M21 3l-7 7M3 21l7-7M9 21H3v-6",
	/** Setas para dentro. Voltar à lateral. */
	minimize: "M14 10l7-7M20 10h-6V4M3 21l7-7M4 14h6v6",
	/** Estrela. A nota que os clientes deram. */
	star: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
	/** Coração. Quem gostou de um post. */
	heart:
		"M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
	/** Prédio. A empresa no registro oficial. */
	building:
		"M10 12h4M10 8h4M14 21v-3a2 2 0 0 0-4 0v3M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16",
	/** Fone. Um número para ligar. */
	phone:
		"M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
	/** Alfinete de mapa. Onde fica. */
	mapPin:
		"M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0M9 10a3 3 0 1 0 6 0a3 3 0 1 0 -6 0",
	/** Paleta. As cores da marca. */
	palette:
		"M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8zM13 6.5a0.5 0.5 0 1 0 1 0a0.5 0.5 0 1 0 -1 0M17 10.5a0.5 0.5 0 1 0 1 0a0.5 0.5 0 1 0 -1 0M6 12.5a0.5 0.5 0 1 0 1 0a0.5 0.5 0 1 0 -1 0M8 7.5a0.5 0.5 0 1 0 1 0a0.5 0.5 0 1 0 -1 0",
	/** Aspas. O que alguém disse. */
	quote:
		"M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
	/** Seta curva para trás. Desfazer. */
	undo: "M9 14 4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11",
	/** Seta curva para a frente. Refazer. */
	redo: "M15 14l5-5-5-5M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13",
	/** Lista em árvore. O sistema, peça dentro de peça. */
	tree: "M8 5h13M13 12h8M13 19h8M3 10a2 2 0 0 0 2 2h3M3 5v12a2 2 0 0 0 2 2h3",
	/** Caixa com seta para cima. Trazer de volta da lixeira. */
	restore:
		"M3 3h18a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1ZM4 8v11a2 2 0 0 0 2 2h2M20 8v11a2 2 0 0 1-2 2h-2M9 15l3-3 3 3M12 12v9",
	/** Cilindro. Uma tela de dados, com as linhas que guarda. */
	database: "M3 5a9 3 0 1 0 18 0a9 3 0 1 0 -18 0M3 5V19A9 3 0 0 0 21 19V5M3 12A9 3 0 0 0 21 12",
	/** Folha de calendário. Uma data marcada. */
	calendar:
		"M8 2v4M16 2v4M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2ZM3 10h18",
	/** Setas em laço. O que volta a acontecer. */
	repeat: "M17 2l4 4-4 4M3 11v-1a4 4 0 0 1 4-4h14M7 22l-4-4 4-4M21 13v1a4 4 0 0 1-4 4H3",

	// ── AS MARCAS ────────────────────────────────────────────────────────────
	// Desenhadas à mão em `scripts/generate-icons.mjs` e CHEIAS, não a contorno:
	// uma silhueta de marca não é um traço. Estão em `FILLED_ICONS`, logo abaixo.
	/** WhatsApp, a marca: o balão com o fone vazado. A porta OFICIAL, da Meta. */
	whatsapp:
		"M4.27 16.25A9.5 9.5 0 1 1 8.79 20.25C7.2 21.05 4.7 21.55 2.6 21.4C3.3 19.7 3.95 17.9 4.27 16.25ZM9.83 6.87A8.4 8.4 0 0 0 16.03 15.71A1.3 1.3 0 0 0 16.7 13.2A5.8 5.8 0 0 1 12.42 7.09A1.3 1.3 0 0 0 9.83 6.87Z",
	/** WhatsApp dentro de um QR. A porta NÃO oficial, a que se pareia lendo o código. */
	whatsappQr:
		"M2.2 1.2h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1ZM3.25 2.9h0.9a0.35 0.35 0 0 1 0.35 0.35v0.9a0.35 0.35 0 0 1 -0.35 0.35h-0.9a0.35 0.35 0 0 1 -0.35 -0.35v-0.9a0.35 0.35 0 0 1 0.35 -0.35ZM18.8 1.2h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1ZM19.85 2.9h0.9a0.35 0.35 0 0 1 0.35 0.35v0.9a0.35 0.35 0 0 1 -0.35 0.35h-0.9a0.35 0.35 0 0 1 -0.35 -0.35v-0.9a0.35 0.35 0 0 1 0.35 -0.35ZM2.2 17.8h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1ZM3.25 19.5h0.9a0.35 0.35 0 0 1 0.35 0.35v0.9a0.35 0.35 0 0 1 -0.35 0.35h-0.9a0.35 0.35 0 0 1 -0.35 -0.35v-0.9a0.35 0.35 0 0 1 0.35 -0.35ZM10.9 1.4h2.2v2.2h-2.2ZM1.4 10.9h2.2v2.2h-2.2ZM19.4 19.4h2.6v2.6h-2.6ZM7.5 14.6A5.2 5.2 0 1 1 9.97 16.79C9.1 17.2 8 17.2 6.95 16.71C7.25 16 7.45 15.3 7.5 14.6ZM10.54 9.47A4.598 4.598 0 0 0 13.93 14.31A0.712 0.712 0 0 0 14.3 12.94A3.175 3.175 0 0 1 11.96 9.59A0.712 0.712 0 0 0 10.54 9.47Z",
} as const satisfies Record<string, string>;

export type IconName = keyof typeof ICONS;

/**
 * Os nomes que se desenham com `fill` em vez de `stroke`.
 *
 * Um conjunto e não uma marca no próprio `d`: o `d` é o traço e nada mais — foi
 * por isso que este arquivo virou um mapa de cadeias —, e quem precisa da resposta
 * é um só (`Icon.vue`). Um nome fora daqui continua saindo a contorno de 2, que é
 * o que as dezenas de ícones do Lucide são.
 */
export const FILLED_ICONS: ReadonlySet<IconName> = new Set(["whatsapp", "whatsappQr"]);
